import React, { Component } from 'react'
import PropTypes from 'prop-types'

import s from './SettingsComponent.css'
import View from '../ViewComponents/View'

const SETTING_TYPES = {
  BOX: 'box',
  TRANSPARENT: 'transparent'
}

const CLASS_NAME_BY_POSITION = {
  bottom: s.setting_bottom,
  bottomRight: s.setting_bottom_right,
  top: s.setting_top_middle,
  DEFAULT: s.setting_top_middle
}

class SettingsComponent extends Component {

  getClassNamesForSetting (settingConfig) {
    let classNames = CLASS_NAME_BY_POSITION[settingConfig.position] || CLASS_NAME_BY_POSITION.DEFAULT
    if (settingConfig.cssClass) {
      classNames += ` ${settingConfig.cssClass}`
    }
    return classNames
  }

  getStyleForSetting (settingConfig) {
    if (settingConfig.bottom || settingConfig.bottom === 0) {
      return {
        bottom: settingConfig.bottom
      }
    }
    return null
  }

  isSettingVisible (settingConfig) {
    if (!settingConfig) {
      return false
    }
    if (settingConfig.id && this.props.settingStates.hasVisibilitySetting(settingConfig.id)) {
      return this.props.settingStates.isVisible(settingConfig.id)
    }
    if (this.props.showSettingsWithId && settingConfig.id && settingConfig.id === this.props.showSettingsWithId) {
      // console.log(`show setting with id ${settingConfig.id} for walktrough`)
      return true
    }
    if (settingConfig.hasOwnProperty('visible')) {
      return settingConfig.visible
    }
    return true
  }

  renderBoxSetting (settingConfig, key) {
    return (
      <div key={key} className={this.getClassNamesForSetting(settingConfig)} style={this.getStyleForSetting(settingConfig)} >
        <View
          config={settingConfig.view}
          functions={this.props.functions}
          filterSettings={this.props.filterSettings}
          setCategoryVisible={this.props.setCategoryVisible}
          setSelectedCountry={this.props.setSelectedCountry}
        />
      </div>
    )
  }

  renderTransparentSetting (settingConfig, key) {
    return (
      <div key={key} className={this.getClassNamesForSetting(settingConfig)} style={this.getStyleForSetting(settingConfig)}>
        <View
          config={settingConfig.view}
          functions={this.props.functions}
          filterSettings={this.props.filterSettings}
          setCategoryVisible={this.props.setCategoryVisible}
        />
      </div>
    )
  }

  renderSetting (settingConfig, key) {
    if (!this.isSettingVisible(settingConfig)) {
      return null
    }

    if (settingConfig.hideInMapView && !this.props.listIsVisible) {
      return null
    }

    if (settingConfig.hideInListView && this.props.listIsVisible) {
      return null
    }

    if (settingConfig.type === SETTING_TYPES.BOX) {
      return this.renderBoxSetting(settingConfig, key)
    }
    if (settingConfig.type === SETTING_TYPES.TRANSPARENT) {
      return this.renderTransparentSetting(settingConfig, key)
    }
    return null
  }

  render () {
    const settingsRendered = this.props.config.map((settingConfig, index) => this.renderSetting(settingConfig, `setting_${index}`)).filter(view => view !== null)
    return (
      <div style={{position: 'absolute', top: 0, left: 0, width: '100vw', height: '100vh', pointerEvents: 'none', zIndex: 10000, transform: 'translate3d(0, 0, 0)'}}>
        {settingsRendered}
      </div>
    )
  }

}

SettingsComponent.propTypes = {
  config: PropTypes.array.isRequired,
  functions: PropTypes.object.isRequired,
  filterSettings: PropTypes.object.isRequired,
  settingStates: PropTypes.object.isRequired,
  setCategoryVisible: PropTypes.func,
  setSelectedCountry: PropTypes.func,
  showSettingsWithId: PropTypes.string,
  listIsVisible: PropTypes.bool
}

export default SettingsComponent



// WEBPACK FOOTER //
// ./src/components/TripAdvisor/SettingsComponent.js